export const environment = {
  state: 'QA',
  BASE_API_URL: 'https://api-khaiminhlandchat-qa.tma-swerp.com',
  CRM_API_URL: 'https://api-crm-khaiminhland-qa.tma-swerp.com',
  CRM_FE_URL: 'https://khaiminhlandcrm-qa.tma-swerp.com',
  //FE_URL: 'https://travel-admin.qasoctrip.com/',
  // ADMIN_HUB_URL: 'https://admin.qasoctrip.com',
  // BE_URL: 'https://api.qasoctrip.com/',
  // IMAGE_URL: 'https://api.qasoctrip.com/ecommerce-management',
  // IFRAME_CONNECT_URL: 'https://admin.qasoctrip.com/app-connect',
  // LOGIN_URL: 'https://qasoctrip.com',
  // SERVICES: {
  //   STOCK: 'stock',
  //   CATALOG: 'catalog',
  //   SHOP: 'shop',
  //   STORAGE: 'storage',
  //   STORAGE_STREAMING: 'storage-streaming',
  //   ORDER: 'order',
  //   PROMOTION: 'promotion',
  //   PAYMENT: 'payment',
  //   SHIPMENT: 'shipment',
  //   ADVERTISING: 'advertising',
  //   TRAVEL_ADMIN: 'travel-admin',
  //   BILLING: 'billing',
  //   REGIONAL: 'regional',
  // },
  // PAGE_TITLE: 'Soctrip',
  // APP_NAME: '',
  // COMPANY_NAME: 'Hahalolo USA',
  // TOKEN: 'token_admin',
  AUTH_STATUS: 'auth_status_admin',
  REFRESH_TOKEN_KEY: 'rft',
  USER_ROLE_KEY: 'a',
  REFRESH_TOKEN_EXPIRY_KEY: 'b',
  ACCESS_TOKEN_EXPIRY_KEY: 'c',
  API_TIMEOUT: 3000,
  USER_PROFILE: 'auth',
  TOKEN_KEY: 'accessToken',
};
